"use strict";
/**
 * @module Services.Security
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a AUTHENTICATOR request.
 */
var AuthenticatorRequest = /** @class */ (function () {
    /**
     * Create a new AuthenticationRequest instance
     *
     * @param principal  the session principal
     * @param credentials  the credentials
     * @param sessionProperties  the current session properties
     * @param proposedProperties  the proposed session properties
     * @param cid  the conversation ID
     */
    function AuthenticatorRequest(principal, credentials, sessionProperties, proposedProperties, cid) {
        this.principal = principal;
        this.credentials = credentials;
        this.sessionProperties = sessionProperties;
        this.proposedProperties = proposedProperties;
        this.cid = cid;
    }
    return AuthenticatorRequest;
}());
exports.AuthenticatorRequest = AuthenticatorRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security/authenticator-request.js
// module id = 1353
// module chunks = 1